/* PS1 papel swags 10/16 (block 308 in kd-custom-35.css). Home, Morse Code Key and collection pages. KD's settings from the Papel swag
   playground (Papel & Polaroid Lab), tuned on her phone shots: widths in % of the page, heights in px for a
   393px phone; on phones (under 768px) every px value scales with the screen (x width / 393), so each swag
   keeps the playground proportions on any phone (her phone is 440px wide). Each swag is drawn as an inline
   SVG (svg.kd-ps1-svg) at the top of its section, holes cut out so the dots show what is beneath.
   pink: the papel under the brown reviews band, PHONES ONLY since PF1 10/16 (computers keep the centred
     TP1 papel, KD 10/16). Adds class kd-ps1, which hides the old papel (that section's ::before). Left end at 55.5%, curve 70% long rising 15.5px; right end at 91%, curve 50%
     long rising 1.5px; roundness 1.2; drop 15.5px; tilt -6px; slide -6%; half moons 20.5px, spacing 1.86,
     holes 1.5px.
   navy (v4 10/16): the top papel under the logo, PHONES ONLY (computers keep the 10/14 tuner navy, TP1).
     Adds class kd-ps1n, which keeps the old papel's room but makes it see-through. Left end at 57.5%, curve
     62% long rising 0px; right end at 70%, curve 57% long rising 18.5px; roundness 1.8; drop 12.5px; tilt 9px;
     slide -2%; half moons 28.5px, spacing 1.7, holes 1.8px.
   key (v5 10/16): the top papel on the Morse Code Key page, PHONES ONLY (tablets and computers keep MK1), in
     her color #2B394F (10/16 7:55am, was #000531). Adds class kd-ps1k, which hides the old papel (that section's ::before). Left end at
     37.5%, curve 70% long rising 19.5px; right end at 70.5%, curve 49.5% long rising 0px; roundness 1.5; drop
     21.5px; tilt -9px; slide 3.5%; half moons 24px, spacing 1.9, holes 1.7px.
   catalog (v6 10/16): the title papel at the top of every collection page (CP2), PHONES ONLY (computers keep
     CP2), live pink var(--kdq-cp2-pink). Adds class kd-ps1c to .kdq-cp2-papel, which makes its own pink and
     hem see-through; the title stays on top. Left end at 29.5%, curve 42.5% long rising 1.5px; right end at
     100%, curve 70% long rising 2px; roundness 2.2; drop 30px; tilt 10px; slide 30%; half moons 27px,
     spacing 1.68, holes 2px.
     Computers (PF1 10/16, KD "thinner at left"): the same swag with its own values (VD), deepest at the right,
     tapering up toward the left: drop 40px, tilt 4px, left 45% rising 12px (roundness 1.6), half moons 21px,
     spacing 1.7, holes 1.8px. Phones unchanged.
   Home colors stay the live ones (navy #264359, rose var(--kdr-rose)). Redrawn on resize. Without this script
   the old papels stay. Built by Opilio Claudio. */
(function () {
  var P = [
    { key: 'pink', cls: 'kd-ps1', sel: '.shopify-section[id$="__section_columns_rzanKM"]', fill: 'var(--kdr-rose,#D48995)', phoneOnly: true,
      V: { start: 55.5, lenL: 70, riseL: 15.5, end: 91, lenR: 50, riseR: 1.5, shape: 1.2, depth: 15.5, tilt: -6, move: -6, moon: 20.5, space: 1.86, hole: 1.5 } },
    { key: 'navy', cls: 'kd-ps1n', sel: '#MainContent .shopify-section[id$="__section_text_tbKkVC"]', fill: '#264359', phoneOnly: true,
      V: { start: 57.5, lenL: 62, riseL: 0, end: 70, lenR: 57, riseR: 18.5, shape: 1.8, depth: 12.5, tilt: 9, move: -2, moon: 28.5, space: 1.7, hole: 1.8 } },
    { key: 'key', cls: 'kd-ps1k', sel: '#MainContent .shopify-section[id$="__kd_morse_key"]', fill: '#2B394F', phoneOnly: true,
      V: { start: 37.5, lenL: 70, riseL: 19.5, end: 70.5, lenR: 49.5, riseR: 0, shape: 1.5, depth: 21.5, tilt: -9, move: 3.5, moon: 24, space: 1.9, hole: 1.7 } },
    { key: 'catalog', cls: 'kd-ps1c', sel: '#kdq-cp2 .kdq-cp2-papel', fill: 'var(--kdq-cp2-pink,#D9A0A3)', phoneOnly: true,
      V: { start: 29.5, lenL: 42.5, riseL: 1.5, end: 100, lenR: 70, riseR: 2, shape: 2.2, depth: 30, tilt: 10, move: 30, moon: 27, space: 1.68, hole: 2 },
      VD: { start: 0, lenL: 45, riseL: 12, end: 100, lenR: 0.1, riseR: 0, shape: 1.6, depth: 40, tilt: 4, move: 0, moon: 21, space: 1.7, hole: 1.8 } }
  ];
  function f(n) { return Math.round(n * 100) / 100; }
  function build(W, V, key, fill) {
    var k = W < 768 ? W / 393 : 1;
    var r = V.moon / 2 * k, per = V.space * r, xs = V.start * W / 100, xe = V.end * W / 100,
        Ll = Math.max(V.lenL, 0.1) * W / 100, Lr = Math.max(V.lenR, 0.1) * W / 100;
    function cy(X) {
      var x = X - V.move * W / 100, c = V.depth * k;
      if (x < xs + Ll) c -= V.riseL * k * Math.pow(Math.max((xs + Ll - x) / Ll, 0), V.shape);
      if (x > xe - Lr) c -= V.riseR * k * Math.pow(Math.max((x - (xe - Lr)) / Lr, 0), V.shape);
      return c + V.tilt * k * (X / W - 0.5);
    }
    var step = Math.max(1, W / 500), pts = [], X;
    for (X = -0.2 * W; X <= 1.2 * W; X += step) pts.push([X, cy(X)]);
    var arc = [0], i;
    for (i = 1; i < pts.length; i++) arc.push(arc[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    var mid = (xs + xe) / 2 + V.move * W / 100;
    var im = Math.min(pts.length - 1, Math.max(0, Math.round((mid + 0.2 * W) / step))), a0 = arc[im];
    var d = 'M' + f(pts[0][0]) + ' -400';
    for (i = 0; i < pts.length; i++) d += 'L' + f(pts[i][0]) + ' ' + f(pts[i][1]);
    d += 'L' + f(pts[pts.length - 1][0]) + ' -400Z';
    var circ = '', holes = '', maxY = 0, j = 0;
    var n0 = Math.ceil(a0 / per), n1 = Math.floor((arc[arc.length - 1] - a0) / per);
    for (var n = -n0; n <= n1; n++) {
      var t = a0 + n * per;
      while (j < arc.length - 1 && arc[j] < t) j++;
      var x = pts[j][0], y = pts[j][1];
      if (y + r < 0) continue;
      var dy = (cy(x + 1) - cy(x - 1)) / 2, L = Math.hypot(dy, 1), nx = -dy / L, ny = 1 / L;
      circ += "<circle cx='" + f(x) + "' cy='" + f(y) + "' r='" + f(r) + "'/>";
      if (V.hole > 0) holes += "<circle cx='" + f(x + nx * r * 0.7) + "' cy='" + f(y + ny * r * 0.7) + "' r='" + f(V.hole * k) + "'/>";
      if (x > -r && x < W + r) maxY = Math.max(maxY, y + r);
    }
    var H = Math.ceil(maxY) + 2, id = 'kdps1m-' + key;
    var svg = "<defs><mask id='" + id + "' maskUnits='userSpaceOnUse' x='0' y='0' width='" + W + "' height='" + H + "'><rect width='" + W + "' height='" + H +
      "' fill='white'/><g fill='black'>" + holes + "</g></mask></defs><g mask='url(#" + id + ")' style='fill:" + fill + "'><path d='" + d + "'/>" + circ + "</g>";
    return { svg: svg, h: H };
  }
  function paint() {
    for (var p = 0; p < P.length; p++) {
      var cfg = P[p], all = document.querySelectorAll(cfg.sel);
      for (var i = 0; i < all.length; i++) {
        var el = all[i], W = Math.round(el.getBoundingClientRect().width), g = el.querySelector(':scope > svg.kd-ps1-svg');
        if (!W) continue;
        if (cfg.phoneOnly && W >= 768 && !cfg.VD) { if (g) g.parentNode.removeChild(g); el.classList.remove(cfg.cls); continue; }
        var s = build(W, W >= 768 && cfg.VD ? cfg.VD : cfg.V, cfg.key, cfg.fill);
        if (!g) {
          g = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          g.setAttribute('class', 'kd-ps1-svg');
          g.setAttribute('aria-hidden', 'true');
          g.setAttribute('focusable', 'false');
          el.insertBefore(g, el.firstChild);
        }
        g.setAttribute('viewBox', '0 0 ' + W + ' ' + s.h);
        g.setAttribute('preserveAspectRatio', 'none');
        g.style.height = s.h + 'px';
        g.innerHTML = s.svg;
        el.classList.add(cfg.cls);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  var tm, lastW = 0;
  window.addEventListener('resize', function () {
    clearTimeout(tm);
    tm = setTimeout(function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; paint(); } }, 120);
  });
})();